// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__1Q4K4","slideIn":"Nav_slideIn__UUVbm","active":"Nav_active__rg6RT"};